export default "__VITE_ASSET__bf6d9548__"